// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__J4ced","closeModalIcon":"PopUpModal_closeModalIcon__L2BJx"};